import AccountBalanceOutlined from '@mui/icons-material/AccountBalanceOutlined';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import EuroIcon from '@mui/icons-material/Euro';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import * as React from 'react';

import { useCurrentEventQuery } from '../../event/hooks/useCurrentEventQuery';
import Typography from './HomeTypography';

export const Informations = () => {
  const { data: currentEventData } = useCurrentEventQuery();
  const currentEvent = currentEventData?.currentEvent ?? null;

  return (
    <Box
      component="section"
      sx={{ display: 'flex', overflow: 'hidden', bgcolor: 'grey.100' }}
    >
      <Container sx={{ mt: 15, mb: 30, display: 'flex', position: 'relative' }}>
        <Box
          component="img"
          src="/home/background-curves.png"
          alt="curvy lines"
          sx={{ pointerEvents: 'none', position: 'absolute', top: -180 }}
        />
        <Grid container spacing={5}>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                px: 5,
              }}
            >
              <EuroIcon fontSize="large" />
              <Typography variant="h5" sx={{ my: 5 }} fontWeight="medium">
                Paiement
              </Typography>
              <Typography variant="h6" fontWeight="regular">
                {currentEvent?.lydiaLink ? (
                  <Typography variant="h6" fontWeight="regular">
                    - Par lydia
                  </Typography>
                ) : null}
                {/* {currentEvent?.canPayByCheck ? (
                  <Typography variant="h6" fontWeight="regular">
                    - Par chèque
                  </Typography>
                ) : null} */}
                {'- Par Hello Asso (carte bancaire en ligne sécurisé)'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                px: 5,
              }}
            >
              <AccountBalanceOutlined fontSize="large" />
              <Typography variant="h5" sx={{ my: 5 }} fontWeight="medium">
                Caution
              </Typography>
              <Typography variant="h6" fontWeight="regular">
                {
                  "Un chèque d'un montant de 133€ sera nécessaire, ainsi qu'un chèque de caution écologique de 10€. Plus d'informations une fois connecté"
                }
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                px: 5,
              }}
            >
              <CurrencyExchangeIcon fontSize="large" />
              <Typography variant="h5" sx={{ my: 5 }} fontWeight="medium">
                Remboursement
              </Typography>
              <Typography variant="h6" fontWeight="regular">
                {'Pour tout remboursement, contacter la Flute.'}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
